import axios from "axios";
import { store } from "../../../state-management/state-mgmt";
import Utility from "../../../shared/utility";
export default {

  getReportingGenericProjectList(call,userId){
  return  this.getData(`rs/ms_project_list?execution_type=1&user_id=${userId}`, call)
  },

  getReportingGenericBusinessList(call,obj){
    return  this.getData(`rs/ms_business_list`, call, obj)
  },
  getReportingGenericWarehouseList(call,obj){ 
    return  this.getData(`rs/ms_warehouse_list`, call, obj)
  },
  getReportingGenericParentClassList(call,obj){ 
    return  this.getData(`rs/ms_parent_class_list`, call, obj)
  },
  getReportingGenericClassList(call,obj){
    return  this.getData(`rs/ms_part_class_list`, call, obj)
  },
  getGenericShipmentList(call,userId){
    return  this.getData(`rs/ms_ship_method?execution_type=1&user_id=${userId}`, call)
  },
  showPartNumDetailsData(call, obj) {
    return this.getData("/rs/ms_part_search", call, obj);
  },
  getSalesOrderRunRateReport(call, obj) {
    return this.getData("rs/rpt_so_run_rate", call, obj, );
  },
  getAssetChangeReport(call, obj) {
    return this.getData("rs/rpt_asset_change", call, obj, );
  },
  getAssetChangeReportFilter(call, obj) {
    return this.getData("rs/rpt_asset_change_filter", call, obj);
  },
  getReportingGenericOrderTypeList(call, obj){
    return this.getData('/rs/ms_order_type', call, obj);
  },
  getReportingShipmentActivityReport(call, obj){
    return this.getData('/rs/rpt_shipment_activity', call, obj)
  },
  getReportingShipmentActivityUserReport(call, obj){
    return this.getData('/rs/rpt_shipment_activity_user', call, obj)
  },
   getReportingShipmentActivityExportReport(call, obj){
    return this.getData('/rs/rpt_shipment_activity_export', call, obj)
  },

     getReportingShipmentActivityDetailSearchReport(call, obj){
    return this.getData('/rs/rpt_shipment_activity_detail_search', call, obj)
  },
     getReportingShipmentActivityDetailSearchExportReport(call, obj){
    return this.getData('/rs/rpt_shipment_activity_detail_search_export', call, obj)
  },

  async getData(url, call, obj, showMessage) {
    let LoaderDialog = {
      visible: true,
      title: "Please Wait...",
    };
    store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    let res = {};
    if (call == "get") {
      res = await axios.get(url).catch(function (error) {
        if (error.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error.response.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    } else {
      res = await axios.post(url, obj).catch(function (error) {
        if (error?.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error?.response?.data?.message ,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    }
    if (res?.data?.body?.message != undefined || res?.data?.body?.message != null) {
      if (!res?.data?.body?.message) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(res?.data?.body?.message),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = res.data.body.message;
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return {};
      }
      try {
        if (showMessage) {
          let Alert = {
            type: "success",
            isShow: true,
            message: this.isJson(res?.data?.body?.message) ? JSON.parse(res?.data?.body?.message).Message : "" || res?.data?.body?.message,
          };
          store.commit("ConfigModule/Alert", Alert);
        }
        LoaderDialog.visible = false;
        if (this.isJson(res?.data?.body?.message))
          return JSON.parse(res?.data?.body?.message) 
        else
          return `{"Status":200,"Message":"${res?.data?.body?.message }"}`
            ;
      } catch (err) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(err),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = err.message;
        return {};
      }
    } else if (res?.data?.body?.message == null) {
      if (res?.data?.body !== null) {
        LoaderDialog.visible = false;
        return res?.data?.body;
      } else {
        LoaderDialog.visible = false;
        return JSON.parse('{"message":"NA"}');
      }
    } else {
      if (!res?.data?.message) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(res?.data.message),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = res?.data?.message;
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return {};
      }
      try {
        if (showMessage) {
          let Alert = {
            type: "success",
            isShow: true,
            message: res.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
        }
        LoaderDialog.visible = false;
        return JSON.parse(res?.data?.message) 
      } catch (err) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(err),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = err.message;
        return {};

      }
    }


  },
  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

};
